export const PLACEHOLDER_REGEX = /\{\{(\d+)\}\}/g;

export const extractPlaceholders = (text) => {
  if (!text) return [];

  const matches = [...text.matchAll(PLACEHOLDER_REGEX)];
  return [...new Set(matches.map((match) => match[1]))].sort(
    (a, b) => Number(a) - Number(b)
  );
};
